var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoolBackgroundWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "topography-shape js-shape",
    width: "1200px",
    height: "580px",
    viewBox: "0 0 1200 580",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1800, 60) scale(2.8, 2.8) skewX(30) ",
    style: {
      position: "relative",
      zIndex: 0,
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1650, 55) scale(2.65, 2.65) skewX(27.5) ",
    style: {
      position: "relative",
      zIndex: 1,
      fill: "rgb(248, 248, 248)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1500, 50) scale(2.5, 2.5) skewX(25) ",
    style: {
      position: "relative",
      zIndex: 2,
      fill: "rgb(241, 241, 241)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1350, 45) scale(2.3499999999999996, 2.3499999999999996) skewX(22.5) ",
    style: {
      position: "relative",
      zIndex: 3,
      fill: "rgb(234, 234, 234)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1200, 40) scale(2.2, 2.2) skewX(20) ",
    style: {
      position: "relative",
      zIndex: 4,
      fill: "rgb(227, 227, 227)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1050, 35) scale(2.05, 2.05) skewX(17.5) ",
    style: {
      position: "relative",
      zIndex: 5,
      fill: "rgb(220, 220, 220)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-900, 30) scale(1.9, 1.9) skewX(15) ",
    style: {
      position: "relative",
      zIndex: 6,
      fill: "rgb(213, 213, 213)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-750, 25) scale(1.75, 1.75) skewX(12.5) ",
    style: {
      position: "relative",
      zIndex: 7,
      fill: "rgb(205, 205, 205)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-600, 20) scale(1.6, 1.6) skewX(10) ",
    style: {
      position: "relative",
      zIndex: 8,
      fill: "rgb(198, 198, 198)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-450, 15) scale(1.45, 1.45) skewX(7.5) ",
    style: {
      position: "relative",
      zIndex: 9,
      fill: "rgb(191, 191, 191)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-300, 10) scale(1.3, 1.3) skewX(5) ",
    style: {
      position: "relative",
      zIndex: 10,
      fill: "rgb(184, 184, 184)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-150, 5) scale(1.15, 1.15) skewX(2.5) ",
    style: {
      position: "relative",
      zIndex: 11,
      fill: "rgb(177, 177, 177)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolBackgroundWhite);
export default __webpack_public_path__ + "static/media/cool-background-white.d3405d3fbb0f5fdce07df4edf770ff7c.svg";
export { ForwardRef as ReactComponent };